export default {
  NAVBAR_MENU_OPENED: 'Navbar menu opened',
  NAVBAR_MENU_CLOSED: 'Navbar menu closed'
};
